import http from 'shared/utils/http';

export const getAppointments = (param) => {
  return http.get('/api/dray/appointment/', param);
};

export const createAppointment = (data) => {
  return http.post('/api/dray/appointment/', data);
};
